import React, { useState, useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import { getAdminSession, getViewAs } from "../utils/adminView";
import Header from "../components/Header";
import ChatBot from "../components/ChatBot";
import { CreativesFiltersProvider } from "../contexts/CreativesFiltersContext";

export default function MainLayout() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedSize, setSelectedSize] = useState("All");
  const [selectedRingSize, setSelectedRingSize] = useState("All");
  const [ringSizeOptions, setRingSizeOptions] = useState([]);
  const [cart, setCart] = useState([]);

  // Default = empty so no product list shows until the dealer picks a
  // section. ProductsPage renders a welcome / dashboard view (pending
  // orders count, total orders, feedback CTA, and an "Order Here →"
  // arrow nudging them to tap a tab) until they make a choice.
  const [activeSection, setActiveSection] = useState("");

  // optional: cart localStorage sync
  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    if (savedCart) {
      try {
        setCart(JSON.parse(savedCart));
      } catch {
        localStorage.removeItem("cart");
      }
    }
  }, []);

  useEffect(() => {
    if (cart.length > 0) {
      localStorage.setItem("cart", JSON.stringify(cart));
    } else {
      localStorage.removeItem("cart");
    }
  }, [cart]);

  // Admin viewing the portal as a dealer → show who, with a switch link.
  const admin = getAdminSession();
  const viewAs = admin ? getViewAs() : null;

  return (
    <CreativesFiltersProvider>
      {admin && (
        <div className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[9999] bg-gray-900/95 text-white text-xs sm:text-sm pl-4 pr-1.5 py-1.5 rounded-full shadow-xl flex items-center gap-3 max-w-[calc(100vw-24px)]">
          <span>
            👁 Admin view:{" "}
            <b>{viewAs ? `${viewAs.firmName || viewAs.phone} (${viewAs.phone})` : "your own account"}</b>
          </span>
          <Link
            to="/select-dealer"
            className="shrink-0 font-bold bg-amber-400 hover:bg-amber-300 text-gray-900 px-3 py-1 rounded-full"
          >
            Switch dealer
          </Link>
        </div>
      )}
      <Header
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedSize={selectedSize}
        setSelectedSize={setSelectedSize}
        selectedRingSize={selectedRingSize}
        setSelectedRingSize={setSelectedRingSize}
        ringSizeOptions={ringSizeOptions}
        cart={cart}
        setCart={setCart}
        activeSection={activeSection}
      />

      <Outlet
        context={{
          searchQuery,
          setSearchQuery,
          cart,
          setCart,
          selectedCategory,
          setSelectedCategory,
          selectedSize,
          setSelectedSize,
          selectedRingSize,
          setSelectedRingSize,
          ringSizeOptions,
          setRingSizeOptions,
          activeSection,
          setActiveSection,
        }}
      />

      <ChatBot />
    </CreativesFiltersProvider>
  );
}